import React from 'react';
import PropTypes from 'prop-types';
import { DragLayer } from 'react-dnd';
import Task from './component';

const layerStyles = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 100,
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    width: '100%',
    height: '100%'
};


const taskWrapperTransform = "scale(1.1)"
const taskWrapperStyle = {
        transform: taskWrapperTransform,
        MsTransform: taskWrapperTransform,
        WebkitTransform: taskWrapperTransform,
        transition: 'transform 200ms'
}

class CustomDragLayer extends React.Component {
    constructor(props) {
        super(props)
        this.getItemStyles = this.getItemStyles.bind(this)
        this.setLayerRef = this.setLayerRef.bind(this)
    }

    rendered = false;
    renderItem(type, item) {
        return (
            <div style={taskWrapperStyle}>
                <Task {...this.props} animate={false} />
            </div>
        );
    }

    getItemStyles() {
        const { currentOffset } = this.props;
        if (!currentOffset || !this.layer) {
            return {
                display: 'none'
            };
        }
        const { left, top } = this.layer.getBoundingClientRect()

        const { x, y } = currentOffset;
        const transform = `translate(${x - left}px, ${y - top}px)`;
        return {
            transform: transform,
            MsTransform: transform,
            WebkitTransform: transform
        };
    }

    setLayerRef(ref) {
        this.layer = ref
    }

    render() {
        const { item, itemType, isDragging } = this.props;
        if (!isDragging || itemType !== 'card') {
            return null;
        }

        return (
            <div style={layerStyles} ref={ this.setLayerRef }>
                <div style={this.getItemStyles(this.props)}>
                    {this.renderItem(itemType, item)}
                </div>
            </div>
        );
    }
}

CustomDragLayer.propTypes = {
    item: PropTypes.object,
    itemType: PropTypes.string,
    currentOffset: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
    }),
    isDragging: PropTypes.bool.isRequired
};

function collect(monitor) {
    return {
        item: monitor.getItem(),
        itemType: monitor.getItemType(),

        currentOffset: monitor.getSourceClientOffset(),
        isDragging: monitor.isDragging()
    };
}

export default DragLayer(collect)(CustomDragLayer);
